import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MastersuiteService {

  constructor(private http: HttpClient) { }

  getMastersuiteById(id) {
    return this.http.get<any>(environment.apiUrl + 'masterSuites/' + id);
  }

  getMasterSuiteList(searchParams) {
    return this.http.post<any>(environment.apiUrl + 'masterSuites/list', searchParams);
  }
  
  executionStart(masterSuiteId, environmentMapperId, params) {
    return this.http.post<any>(environment.apiUrl + 'executors/masterSuites/' + masterSuiteId + '/environmentMappers/' + environmentMapperId, params);
  }

  getEnv(id: number) {
    return this.http.get<any>(environment.apiUrl + 'environmentMaps/projects/' + id);
  }

  getMasterSuiteDetails(id) {
    return this.http.get<any>(environment.apiUrl + 'masterSuites/' + id);
  }

  getMasterSuiteTestSuites(id) {
    return this.http.get<any>(environment.apiUrl + 'masterSuites/' + id + '/masterSuiteTestSuites');
  }

  getTestcasesByTestSuiteId(id) {
    return this.http.get<any>(environment.apiUrl + 'testSuites/' + id + '/testSuiteTestCases/shortData') 
  }

  getTestSuiteList(postData) {
    return this.http.post<any>(environment.apiUrl + 'testSuites/list', postData);
  }

  getAssociateShortData(id: number) {
    return this.http.get<any>(environment.apiUrl + 'masterSuites/' + id + '/masterSuiteTestSuites');
  }

  createNewMasterSuite(postData) {
    return this.http.post<any>(environment.apiUrl + 'masterSuites',postData);
  }

  updateMasterSuite(obj: any) {
    return this.http.put<any>(environment.apiUrl + 'masterSuites', obj);
  }

  assocDissocTestSuite(id, postData) {
    return this.http.post<any>(environment.apiUrl + 'masterSuites/' + id + '/associateDissociateTestSuites', postData);
  }

  getMasterSuiteResultByExecutionId(noSqlId): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'result/masterSuite/execution/noSqlId/' + noSqlId);
  }

  getMostRecentExec(id): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'result/masterSuite/sqlId/' + id + '/lastExecution');
  }

  getResultTSuite(noSqlId, pageNo, size): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'result/testSuite/noSqlId/' + noSqlId + '/pages/' + pageNo + '/size/' + size);
  }

  deleteMultipleMastersuites(entityType: string,entityIdList: number[]): Observable<any> {
    const options = {
      body: {
        entityType,
        entityIdList
      }
    };
     return this.http.delete<any>(`${environment.apiUrl}masterSuites/bulkDelete`, options);
  }
}
